export default __webpack_public_path__ + "static/media/f0015-01.3916c05b.png";